












import {Vue, Component} from "vue-property-decorator";

@Component
export default class NoEvents extends Vue {
    async logout() {
        await this.$store.dispatch('resetSession');
        this.$analytics.setGtagParams(false, true);
        this.$router.push({name: 'Login', params: { backend: this.$route.params.backend, eventId: this.$route.params.eventId } });
    }

    get title() {
        return this.$store.getters['services/getServiceParam']('eventsManagement', 'noEventsMessage')?.title ?? this.$t('no-events.title')
    }

    get body() {
        return this.$store.getters['services/getServiceParam']('eventsManagement', 'noEventsMessage')?.body ?? this.$t('no-events.text')
    }
}
